import axios from 'axios';
import { config } from '../config';
import { authService } from './auth';

const api = axios.create({
  baseURL: config.api.baseUrl
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(async (config) => {
  const token = await authService.getIdToken();
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

export const qrCodeService = {
  // Método legado - retorna todos (para compatibilidade)
  list: async () => {
    const response = await api.get('/qrcodes');
    // Se a API retornar formato novo, extrair items
    if (response.data.items) {
      return response.data.items;
    }
    return response.data;
  },

  // Novo método com paginação server-side
  listPaginated: async ({ page = 1, limit = 12, search = '' } = {}) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    if (search) params.append('search', search);

    const response = await api.get(`/qrcodes?${params.toString()}`);
    return response.data; // { items, totalCount, totalPages, currentPage, hasMore }
  },

  get: async (id) => {
    const response = await api.get(`/qrcodes/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/qrcodes', data);
    return response.data;
  },

  update: async (data) => {
    const response = await api.put('/qrcodes', data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/qrcodes/${id}`);
    return response.data;
  }
};

export const reportService = {
  get: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.qrId) params.append('qrId', filters.qrId);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);

    const response = await api.get(`/reports?${params.toString()}`);
    return response.data;
  }
};

export const templateService = {
  list: async () => {
    const response = await api.get('/templates');
    return response.data;
  },

  get: async (id) => {
    const response = await api.get(`/templates/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/templates', data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/templates/${id}`);
    return response.data;
  }
};